registerGlobal('EmscriptenFacebook');
EmscriptenFacebook.callAfterInit = [];
EmscriptenFacebook.initialized = false;

EmscriptenFacebook.delayCallAfterInit = function(f, args) {
    if (EmscriptenFacebook.initialized) return false;
    EmscriptenFacebook.callAfterInit.push(function() {
        f.apply(null, args);
    });
    return true;
};

EmscriptenFacebook.initialize = function(fbAppId, cb) {
    //already EmscriptenFacebook.initialized before application launch, send login data
    if (EmscriptenFacebook['statusData'] && Module['EmscriptenFacebookLoginStatusCallback']) {
        Module.EmscriptenFacebookLoginStatusCallback(EmscriptenFacebook.statusData.uid,
            'connected',
            EmscriptenFacebook.statusData.accessToken,
            EmscriptenFacebook.statusData.userName,
            EmscriptenFacebook.statusData.expiresIn);
    }

    if (EmscriptenFacebook.initialized) {
        if (cb) cb();
        return;
    }
    window.fbAsyncInit = function() {
        FB.init({
            appId      : fbAppId,
            xfbml      : true,
            version    : 'v2.7'
        });

        EmscriptenFacebook.initialized = true;
        for (var i = 0; i < EmscriptenFacebook.callAfterInit.length; i++) EmscriptenFacebook.callAfterInit[i]();
        EmscriptenFacebook.callAfterInit = [];

        if (cb) cb();
    };

    (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
}

EmscriptenFacebook._onLoginResponse = function(response, cb) {
    if (response.status === 'connected') {
        var uid = response.authResponse.userID;
        var accessToken = response.authResponse.accessToken;
        var expiresIn = response.authResponse.expiresIn || 90 * 60;

        EmscriptenFacebook.statusData = { uid: uid, accessToken: accessToken, expiresIn: expiresIn };
        console.log("EmscriptenFacebook accessToken: " + accessToken + " received at: " + (new Date()));

        FB.api('/me/permissions', function(permission_response) {
            if (permission_response && !permission_response.error && permission_response.data) {
                var granted_permissions = [];
                var declined_permissions = [];
                for (i = 0; i < permission_response.data.length; i++) {
                    if (permission_response.data[i].status == 'granted') {
                        granted_permissions.push(permission_response.data[i].permission)
                    }
                    else if (permission_response.data[i].status == 'declined') {
                        declined_permissions.push(permission_response.data[i].permission)
                    }
                }
                EmscriptenFacebook.granted_permissions = granted_permissions;
                EmscriptenFacebook.declined_permissions = declined_permissions;
            }
            if (permission_response && permission_response.error) {
                console.log("EmscriptenFacebook API error: " + permission_response.error.code + " " + permission_response.error.error_subcode + " " + permission_response.error.message);
            }
            if (permission_response && permission_response.error && permission_response.error.code == 190 && !forceRefresh) {
                // Access token has expired, but force wasn't enabled
                console.log("EmscriptenFacebook Access token has expired, force refresh");
                EmscriptenFacebook.getLoginStatus(cb, true);
            }
            else {
                EmscriptenFacebook.requestUserName(function(userName) {
                    EmscriptenFacebook.statusData.userName = userName;
                    if (Module['EmscriptenFacebookLoginStatusCallback']) Module.EmscriptenFacebookLoginStatusCallback(uid, response.status, accessToken, userName, expiresIn);
                    if (cb) cb();
                });
            }
        });
    }
    else if (response.status === 'not_authorized') {
        console.log("EmscriptenFacebook User not authorized, but logged in into facebook");
        if (Module['EmscriptenFacebookLoginStatusCallback']) Module.EmscriptenFacebookLoginStatusCallback('-1', response.status, "", "", 0);
        if (cb) cb();
    }
    else if (response.status === 'unknown') {
        EmscriptenFacebook.login(false, false, null, cb);
    }
    else {
        console.log("EmscriptenFacebook Not logged in. Logging in");
        if (Module['EmscriptenFacebookLoginStatusCallback']) Module.EmscriptenFacebookLoginStatusCallback('-1', 'not_logged_in', "", "", 0);
        if (cb) cb();
    }
};

EmscriptenFacebook.getLoginStatus = function(cb, forceRefresh) {
    if (EmscriptenFacebook.delayCallAfterInit(EmscriptenFacebook.getLoginStatus, [])) return;
    forceRefresh = (typeof forceRefresh !== 'undefined') ? forceRefresh : true;
    FB.getLoginStatus(function(response) {
        EmscriptenFacebook._onLoginResponse(response, cb);
    }, forceRefresh);
}

EmscriptenFacebook.login = function(email, rerequest, additionalScope, cb) {
    if (EmscriptenFacebook.delayCallAfterInit(EmscriptenFacebook.login, [email, rerequest])) return;
    console.log("EmscriptenFacebook Logging in");

    var scope;
    if (email) {
        scope = "user_friends,email";
    }
    else {
        scope = "user_friends";
    }

    if (additionalScope) {
        scope = scope + "," + additionalScope.join(',');
    }

    var options = { scope: scope };
    if (rerequest) options["auth_type"] = "rerequest";

    FB.login(function(response) {
        EmscriptenFacebook._onLoginResponse(response, cb);
    }, options);
}

EmscriptenFacebook.requestUserName = function(cb) {
    console.assert(EmscriptenFacebook.initialized, "EmscriptenFacebook.getUserName called before initialization.");
    FB.api(
        "/me", { fields: "name" },
        function(response) {
            if (response && !response.error) {
                cb(response.name);
            }
            else {
                cb("");
            }
        }
    );
};

EmscriptenFacebook.NativeRequestPermissions = function(nativePermissions) {
    //Exit Fullscreen first
    if (document.exitFullscreen) {
        document.exitFullscreen();
    }
    else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    }
    else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    }
    else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    }
    var rerequest = false;
    var permissions = [];
    for (var i = 0; i < nativePermissions.size(); i++) {
        var p = nativePermissions.get(i);
        permissions.push(p);
        if (EmscriptenFacebook.isPermissionDeclined(p)) rerequest = true;
    }

    EmscriptenFacebook.login(false, rerequest, permissions);
}

EmscriptenFacebook.NativeGraphRequest = function(path, params1, params2, method, callback, arg) {
    var jsParams = {};
    for (var i = 0; i < params1.size(); i++) {
        jsParams[params1.get(i)] = encodeURI(params2.get(i));
    }

    FB.api(path, method, jsParams, function(response) {
        console.log(response);
        var resp = 0;
        var success = 0;
        if (response && !response.error) {
            var textResp = JSON.stringify(response);
            var len = lengthBytesUTF8(textResp) + 1;
            var resp = _malloc(len);
            stringToUTF8(textResp, resp, len);
            success = 1;
        }

        if (callback) dynCall('viii', callback, [arg, success, resp]);

        if (resp) _free(resp);
    });
}

EmscriptenFacebook.isPermissionGranted = function(permission) {
    return EmscriptenFacebook.granted_permissions.indexOf(permission) !== -1;
}

EmscriptenFacebook.isPermissionDeclined = function(permission) {
    return EmscriptenFacebook.declined_permissions.indexOf(permission) !== -1;
}

EmscriptenFacebook.getEmail = function(id) {
    console.assert(EmscriptenFacebook.initialized, "EmscriptenFacebook.getEmail called before initialization.");
    FB.api(
        "/" + id, { fields: 'email' },
        function(response) {
            if (response && !response.error && response.email) {
                Module.EmscriptenFacebookGetEmailCallback(response.email, true);
            }
            else {
                Module.EmscriptenFacebookGetEmailCallback("", true);
            }
        }
    );
}

EmscriptenFacebook.ShowGameRequestDialog = function(msg) {
    console.assert(EmscriptenFacebook.initialized, "EmscriptenFacebook.ShowGameRequestDialog called before initialization.");
    if (EmscriptenFacebook.isPermissionDeclined("user_friends")) {
        EmscriptenFacebook.login(false, true);
        return;
    }
    if (!EmscriptenFacebook.isPermissionGranted("user_friends")) {
        EmscriptenFacebook.login(false);
        return;
    }
    FB.ui({
        method: 'apprequests',
        message: msg,
        filters: ['app_non_users']
    }, function(response) {});
}

EmscriptenFacebook.DeleteGameRequests = function() {
    console.assert(EmscriptenFacebook.initialized, "EmscriptenFacebook.DeleteGameRequests called before initialization.");
    var deleteRequest = function(requestId) {
        FB.api(requestId, 'delete', function(response) {});
    };
    FB.api('/me/apprequests', function(response) {
        if (!response || response.error || !response.data) return;
        for (var i = 0; i < response.data.length; i++) {
            deleteRequest(response.data[i].id);
        }
    });
}

//if preRunFbid is set, initialize facebook before launching application
if (EmscriptenFacebook.preRunFbid) {
    var delayRunUntilLoginStatus = function(fbid) {
        Module.addRunDependency("EmscriptenFacebook");
        EmscriptenFacebook.initialize(fbid, function() {
            EmscriptenFacebook.getLoginStatus(function() { Module.removeRunDependency("EmscriptenFacebook"); }, false);
        });
    };

    Module.preInit = Module.preInit || [];
    Module.preInit.push(function() {
        delayRunUntilLoginStatus(EmscriptenFacebook.preRunFbid);
    });
}



//////////////////
// WEBPACK FOOTER
// /src/contrib/facebook/emscripten/js/Application.facebook.js
// module id = 32
// module chunks = 0